import { StyleSheet, Platform, Dimensions } from 'react-native';
import { yellowDarkColor, blueDarkColor, redColor, darkColor, redShadowColor } from './colors';
import { wp, hp } from '../utils/responsive';
var {  height } = Dimensions.get('window');
export const appStyles = StyleSheet.create({
    container: {
        flex: 1,
        width:wp(100),
        alignSelf:'center',
        backgroundColor: 'white',
        paddingTop: Platform.OS === 'ios' ? 20 : 0,
    },
    bottomModalTitle: {
        flexGrow: 2,
        color: 'black',
        textAlign: 'center',
        marginLeft: 50
    },
    backImage: {
        width: 20,
        height: 20,
        resizeMode: 'contain',
        margin: 5
    },
    rightText: {
        textAlign: 'right'
    },
    whiteTextInput: {
        color: 'white',
        fontSize: 16
    },
    outlineTextInput: {
        backgroundColor: 'transparent',
        width: wp(80),
        margin: 5,
    },
    outlineTextInputSup: {
        borderRadius: 8,
        color: 'black',
        backgroundColor: 'transparent',
        width: wp(100) - 100,
    },

    outlineTextInputMid: {
        backgroundColor: 'transparent',
        width: wp(38.5),
        margin: 5,
    },
    outlineTextInputWhite: {
        backgroundColor: 'white',
        alignSelf: 'center',
        borderRadius: 8,
        width: wp(80),
        margin: 5,
    },
    outlineTextInputWhiteMid: {
        backgroundColor: 'white',
        alignSelf: 'center',
        borderRadius: 8,
        width: wp(40),
        margin: 5,
    },
    textCenter: {
        textAlign: 'center',
        color: '#4D4C53'
    },
    boxWraper: {
        width: wp(85),
        backgroundColor: 'white',
        borderRadius: 15,
        minHeight: wp(80),
        marginTop: 35,
        alignItems: 'center',
        justifyContent: 'space-around',
        paddingTop: 35
    },
    shadow: {
        shadowColor: "#000000",
        shadowOffset: {
            width: 0,
            height: 3,
        },
        shadowOpacity: 0.2,
        shadowRadius: 6,
        elevation: 10,
    },
    bottomView: {
        alignSelf:'center',
        backgroundColor: 'white',
        borderTopLeftRadius: 50,
        borderTopRightRadius: 50,
        position: 'absolute',
        alignItems: 'center',
        bottom: 0,
        width: wp(100),
        minHeight: 120,
    },
    bottomViewSimple: {
        backgroundColor: 'white',
        paddingTop: 10,
        paddingBottom: 10,
        borderTopLeftRadius: 50,
        borderTopRightRadius: 50,
        alignItems: 'center',
        width: wp(100),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    rowAround: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center'
    },
    center: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    rowBetween: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 10
    },
    dropdown: {
        width: wp(6),
        height: wp(6),
        resizeMode: 'contain',
        tintColor: blueDarkColor
    },
    adLogo: {
        width: hp(5),
        height: hp(5),
        resizeMode: 'contain'
    },
    screenTitle: {
        color: 'white',
        fontSize: hp(2)
    },
    textInput: {
        borderWidth: 1,
        borderRadius: 8,
        minHeight: hp(7),
        borderColor: '#EEEEEE',
        margin: 5,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        width: wp(80),
    },
    whitetextInput: {
        borderRadius: 8,
        backgroundColor: '#FCFCFC',
        borderColor: '#FFFFFF',
        borderWidth: 1,
        margin: 5,
        alignItems: 'center',
        justifyContent: 'center',
        width: wp(90),
        height: 45,
    },
    textInputText: {
        width: wp(100) - 140,
    },
    toolbarWraper: {
        height: hp(7),
        width: wp(100),
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        paddingLeft: 10,
        paddingRight: 10
    },
    toolbarIcon: {
        width: hp(4),
        height: hp(4),
        resizeMode: 'contain',
        margin: 5
    },
    smallIcon: {
        width: wp(5),
        height: wp(5),
        resizeMode: 'contain',
    },
    backIcon: {
        width: 20,
        height: 20,
        resizeMode: 'contain',
        margin: 10
    },
    toolbarTitle: {
        color: darkColor,
        fontSize: hp(2.2),
        textAlign: 'center'
    },
    buttonText: {
        color: 'white',
        fontSize: 16,
        textAlign: 'center'
    },
    flex1: {
        flex: 1
    },
    fabIconWraper: {
        position: 'absolute',
        bottom: 30,
        right: 20,
        width: 60,
        overflow: 'hidden',
        height: 60,
        borderRadius: 30,
        justifyContent: 'center',
        alignItems: 'center'
    },
    fabIcon: {
        width: 60,
        overflow: 'hidden',
        height: 60,
        borderRadius: 30,
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalMessageContent: {
        backgroundColor: 'white',
        borderRadius: 10,
        width: wp(90),
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center'
    },

    modalContent: {
        backgroundColor: 'white',
        borderRadius: 10,
        width: wp(95),
        maxHeight: hp(90),
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalSearchContent: {
        backgroundColor: 'white',
        width: wp(100),
        height: hp(100),
        maxHeight: hp(100),
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalMessageAbsolute: {
        width: wp(100),
        height: height,
        alignSelf:'center',
        position: 'absolute',
        backgroundColor: '#00000066',
        justifyContent: 'center',
        alignItems: 'center'
    },
    midButton: {
        minWidth: wp(100) / 3,
        width: wp(100) / 3,
        height: 40,
    },
    outlineButton: {
        paddingLeft: 20,
        paddingRight: 20,
        minWidth: 150,
        height: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderRadius: 20,
        borderColor: '#C0C0C0'
    },
    button: {
        width: 200,
        height: 50,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: blueDarkColor,
        borderRadius: 10,
        margin: 20,
        alignSelf: 'center'
    },
    completeOrderwraper: {
        paddingTop: 10,
        borderTopLeftRadius: 40,
        borderTopRightRadius: 40,
        borderBottomLeftRadius: 40,
        borderBottomRightRadius: 40,
        flex: 1,
        width: wp(100),
        // paddingBottom: 130,
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    completeLongOrderwraper: {
        paddingTop: 10,
        borderTopLeftRadius: 40,
        borderTopRightRadius: 40,
        borderBottomLeftRadius: 40,
        borderBottomRightRadius: 40,
        flex: 1,
        width: wp(100),
        // paddingBottom: 130,
        justifyContent: 'space-between',
        alignItems: 'center'
    }

})

export const componentStyles = StyleSheet.create({
    modalBackground: {
        width: wp(100),
        height: height,
        justifyContent: 'flex-end',
    },
    addfavWraper: {
        borderWidth: 1,
        borderColor: '#eeeeee',
        borderRadius: 5,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        padding: 5,
        marginTop: 10
    },
    choseButton: {
        width: 100,
        height: 100,
        borderRadius: 8,
        backgroundColor: '#eeeeee',
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalFadeBackground: {
        width: wp(100),
        height: height,
        backgroundColor: '#000000B3',
        position: 'absolute'
    },
    modalBottomContent: {
        backgroundColor: 'white',
        borderTopLeftRadius: 20,
        maxHeight: height - 50,
        borderTopRightRadius: 20, padding: 20
    },
    selectActivePay: {
        width: wp(40),
        height: hp(8),
        justifyContent: 'space-around',
        alignItems: 'center',
        borderBottomWidth: 2,
        borderBottomColor: '#31CF75'
    },
    selectPay: {
        width: wp(40),
        height: hp(8),
        justifyContent: 'space-around',
        alignItems: 'center',
        borderBottomWidth: 2,
        borderBottomColor: '#F1F1F1'
    },
    paymentButton: {
        width: wp(28),
        height: hp(6),
        margin: 5,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#E9E9E9'
    },
    paymentActiveButton: {
        width: wp(28),
        height: hp(6),
        margin: 5,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31C5D5',
        borderRadius: 8,
    },
    paymentTextActive: {
        fontSize: 12,
        color: 'white'
    },
    payementText: {
        fontSize: 12,
        color: '#4D4C53'
    },
    rateImage: {
        width: wp(10),
        height: wp(10),
        resizeMode: 'contain',
        margin: 5,
    },
    requestText: {
        flexGrow: 2, color: 'white',
        textAlign: 'center',
    },
    countWraper: {
        width: 40, height: 40, borderRadius: 25,
        backgroundColor: 'white',
        justifyContent: 'center',
        alignItems: 'center', margin: 10
    },
    serviceItemWraper: {
        width: wp(29),
        height: wp(29),
        borderRadius: 15,
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        margin: wp(2),
    },
    serviceInfoItemWraper: {
        width: wp(28),
        height: wp(28),
        borderRadius: 15,
        justifyContent: 'center',
        // backgroundColor: 'white',
        alignItems: 'center',
        overflow: 'hidden',
        margin: wp(2),
    },
    selectedService: {
        // borderRadius: 15,
        borderWidth: 2,
        // margin: 3,
        borderColor: 'white',

    },
    serviceImage: {
        width: hp(12),
        height: hp(12),
        alignSelf: 'center',
    },
    fservantImage: {
        width: wp(16),
        height: wp(16),
        margin: 5,
        borderWidth: 3,
        borderColor: '#29b6f6',
        overflow: 'hidden',
        borderRadius: wp(16) / 2,
    },
    iservantImage: {
        width: wp(16),
        height: wp(16),
        borderRadius: wp(16) / 2,
        overflow: 'hidden'
    },
    servantImage: {
        width: wp(20),
        height: wp(20),
        borderRadius: wp(20) / 2,
        overflow: 'hidden'
    },
    mapFavoritWraper: {
        height: height / 4,
        borderRadius: 30,
        overflow: 'hidden'
    },
    choseDesButton: {
        position: 'absolute',
        left: 30,
        bottom: 20,
        height: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 20,
        width: 150
    },
    favoritAddressWraper: {
        width: wp(100) - 40,
        margin: 20,
        borderRadius: 30,
        overflow: 'hidden',
        paddingTop: 10
    },
    activeButton: {
        width: 60,
        height: 30,
        borderRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white'
    },
    deactiveButton: {
        width: 60,
        height: 30,
        borderRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
    },
    activeTextButton: {
        color: blueDarkColor
    },
    deactiveTextButton: {
        color: 'white'
    },
    switchButtonWraper: {
        borderWidth: 1,
        borderColor: 'white',
        borderRadius: 8,
        padding: 5,
        flexDirection: 'row',
        alignItems: 'center'
    },
    infoButton: {
        width: wp(20),
        height: hp(3),
        borderRadius: 15,
    },
    actionFavoritWraper: {
        width: (wp(100) - 70) / 2,
        marginTop: 10,
        marginBottom: 10,
        justifyContent: 'space-around',
        flexDirection: 'row',
        alignItems: 'center'
    },
    editButtonWraper: {
        width: wp(18),
        height: 30,
        borderRadius: 10,
        flexDirection: 'row',
        backgroundColor: '#43EC8C',
        justifyContent: 'center',
        alignItems: 'center'
    },
    removeButtonWraper: {
        width: wp(18),
        height: 30,
        borderRadius: 10,
        flexDirection: 'row',
        backgroundColor: '#FF6150',
        justifyContent: 'center',
        alignItems: 'center'
    },
    notifictionWraper: {
        backgroundColor: 'white',
        width: wp(100) - 40,
        padding: 10,
        marginTop: 20,
        marginLeft: 20,
        marginRight: 20,
        borderRadius: 20
    },
    favoirtPersonItem: {
        width: (wp(100) - 50) / 2,
        marginRight: 10,
        marginLeft: 10,
        marginBottom: 10,
        height: (wp(100) - 90) / 2,
        backgroundColor: 'white',
        borderRadius: 20,
        justifyContent: 'center',
        alignItems: 'center'
    },
    favoirtExpertItem: {
        width: (wp(100) - 50),
        marginRight: 10,
        marginLeft: 10,
        marginBottom: 10,
        height: (wp(100) - 110) / 2,
        backgroundColor: '#fafafa',
        borderRadius: 20,
        justifyContent: 'center',
        alignItems: 'flex-end'
    },
    roundInput: {
        borderWidth: 1,
        borderRadius: 25,
        borderColor: '#EEEEEE',
        margin: 5,
        alignItems: 'center',
        justifyContent: 'center',
        width: wp(70),
        height: 50,
    },
    sessionIndexWraper: {
        width: 30,
        height: 30,
        borderRadius: 8,
        justifyContent: 'center',
        alignItems: 'center'
    },
    sessionItem: {
        width: wp(100) - 60,
        borderBottomColor: '#F8F8F8',
        borderBottomWidth: 1,
        flexDirection: 'row',
        alignSelf: 'center',
        alignItems: 'center',
        padding: 5,
        marginBottom: 5,
        justifyContent: 'space-around'
    },
    statusWraper: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        height: 30,
        borderRadius: 15
    },
    growBetween: {
        flexGrow: 2,
        justifyContent: 'space-between'
    },
    infoButtonText: {
        color: 'white',
        textAlign: 'center'
    },
    requestItem: {
        width: wp(100) - 40,
        borderRadius: 20,
        marginTop: 10,
        backgroundColor: 'white',
        justifyContent: 'space-between',
        height: 130,
        marginLeft: 20,
        marginRight: 20,
        alignItems: 'center',
        flexDirection: 'row',
        shadowColor: "#000000cc",
        shadowOffset: {
            width: 0,
            height: 3,
        },
        shadowOpacity: 0.05,
        shadowRadius: 2.27,
        elevation: 2,
    },
    cartItem: {
        width: wp(90),
        borderRadius: 20,
        marginTop: 10,
        backgroundColor: 'white',
        padding: 5,
        justifyContent: 'space-between',
        marginLeft: 20,
        marginRight: 20,
        alignItems: 'center',
        flexDirection: 'row',
        shadowColor: "#000000cc",
        shadowOffset: {
            width: 0,
            height: 3,
        },
        shadowOpacity: 0.05,
        shadowRadius: 2.27,
        elevation: 2,
    },
    cartImageWraper: {
        width: wp(20),
        height: wp(20),
        borderRadius: 20,
        margin: 5,
        justifyContent: 'center',
        alignItems: 'center'
    },
    requestImageWraper: {
        width: hp(16),
        height: hp(16),
        borderRadius: 20,
        margin: 5,
        justifyContent: 'center',
        alignItems: 'center'
    },
    requestImage: {
        width: wp(20),
        height: wp(20),
        resizeMode: 'contain',
    },
    menuHeaderWraper: {
        width: wp(80)>300?300:wp(80),
        height: hp(15),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: 10,
        paddingRight: 10,
        borderBottomRightRadius: 40,
        borderBottomLeftRadius: 40,
        marginBottom: 30,
    },
    smallIconWhite: {
        width: hp(5),
        height: hp(5),
        marginLeft: wp(1),
        resizeMode: 'contain',
        tintColor: 'white'
    },
    menuTitle: {
        color: 'white',
        textAlign: 'center',
        fontSize: hp(2)
    },
    menuIcon: {
        marginRight: 30,
        marginLeft: 20,
        tintColor: darkColor,
        width: wp(6),
        height: wp(6),
        resizeMode: 'contain'
    },
    favoritPersonIcon: {
        margin: 10,
        tintColor: 'black',
        width: 35,
        height: 35,
        resizeMode: 'contain'
    },
    favoritIcon: {
        marginRight: 5,
        marginLeft: 5,
        tintColor: darkColor,
        width: 25,
        height: 25,
        resizeMode: 'contain'
    },

    menuItem: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginBottom: 25
    },
    favoritItem: {
        flexDirection: 'row',
        marginLeft: 10,
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    gradinatButton: {
        flexDirection: 'row',
        minHeight: hp(4),
        minWidth: wp(15),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10,
    },
    text: {
        fontFamily: 'IRANSansMobile',
        color: 'white',
    },
    textBold: {
        fontFamily: 'IRANSansMobile',
        fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
        color: 'white',
    },
})
export const splashStyles = StyleSheet.create({
    container:
    {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    image: {
        width: 150,
        height: 150,
        resizeMode: 'contain'
    },
    textWraper: {
        width: 200,
        height: 50,
        margin: 10,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10,
        backgroundColor: yellowDarkColor
    },
    title: {
        color: 'white',
        textAlign: 'center',
        fontSize: 14
    }
})

export const loginStyles = StyleSheet.create({
    container:
    {
        flex: 1,
    },
    center: {
        justifyContent: 'center',
        flex: 1,
        marginBottom: 200,
        alignItems: 'center'
    },
    text: {
        color: blueDarkColor,
        textAlign: 'center',
        fontSize: hp(1.7)
    },
    buttonText: {
        color: 'white',
        textAlign: 'center',
        fontSize: hp(1.8)
    },
    button: {
        borderColor: blueDarkColor,
        borderWidth: 1,
        marginLeft: 20,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10,
        minHeight: hp(6),
        minWidth: wp(40),
    },
    image: {
        width: wp(40),
        height: wp(40),
        resizeMode: 'contain',
        tintColor: 'white',
        alignSelf: 'center'
    },
    circleWraper: {
        width: wp(20),
        height: wp(20),
        borderRadius: wp(20) / 2,
        marginBottom: wp(10),
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center'
    },
    icon: {
        width: wp(10),
        height: wp(10),
        resizeMode: 'contain',
        tintColor: 'white'
    },
    wraper: {
        justifyContent: 'space-between',
        flex: 1,
        width: wp(100),
        alignItems: 'center',
        padding: 20
    }
})

export const homeStyles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#eeeeee'
    },
    sliderWraper: {
        width: wp(100),
        marginTop: 20,
        marginBottom: 20,
        justifyContent: 'center',
        alignItems: 'center'
    },
    sliderItem: {
        width: wp(85),
        backgroundColor: 'white',
        maxWidth: wp(85),
        height: hp(30),
        maxHeight: hp(30),
        borderRadius: 20,
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: "#000000cc",
        shadowOffset: {
            width: 0,
            height: 5,
        },
        shadowOpacity: 0.1,
        shadowRadius: 6.27,
        elevation: 10,
    },
    notifictionCount: {
        color: 'white',
        fontSize: 12
    },
    notifictionWraper: {
        width: 20,
        height: 20,
        borderRadius: 10,
        backgroundColor: redColor,
        justifyContent: 'center',
        alignItems: 'center'
    },
    slider: {
        marginTop: 10,
        width: wp(100),
        height: hp(38),
    },
    sliderImage: {
        borderRadius: 20,
        overflow: 'hidden',
        width: wp(85),
        backgroundColor: 'white',
        resizeMode: 'contain',
        height: hp(30),
        maxHeight: hp(30),
    },
    // sliderWraper: {
    //     width: wp(85),
    //     // marginLeft: wp(7.5),
    //     // marginRight: wp(7.5),
    //     backgroundColor: 'white',
    //     maxWidth: wp(85),
    //     height: hp(30),
    //     maxHeight: hp(30),
    //     borderRadius: 20,
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     shadowColor: "#000000cc",
    //     shadowOffset: {
    //         width: 0,
    //         height: 5,
    //     },
    //     shadowOpacity: 0.1,
    //     shadowRadius: 6.27,
    //     elevation: 10,
    // },
    requestButton: {
        width: wp(85),
        height: hp(10),
        marginTop: 30,
        marginBottom: 10,
        borderRadius: 15,
        alignSelf: 'center',
    },
    button: {
        flexDirection: 'row',
        padding: 10,
        width: wp(40),
        height: hp(15),
        borderRadius: 15,
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    favExbutton: {
        flexDirection: 'row',
        width: wp(35),
        margin: 5,
        height: hp(6),
        borderRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonText: {
        color: 'white',
        marginBottom: 10,
        fontSize: 14,
        textAlign: 'right'
    },
    buttonTitle: {
        color: 'white',
        textAlign: 'right',
        fontSize: 16,
        marginRight: 10
    },
    icon: {
        width: wp(12),
        height: wp(12),
        resizeMode: 'contain'
    },
    bicon: {
        width: wp(15),
        height: wp(15),
        resizeMode: 'contain'
    },
    sicon: {
        width: wp(6),
        height: wp(6),
        margin: 5,
        resizeMode: 'contain',
        tintColor: 'white'
    },
    sosButton: {
        width: wp(25),
        height: wp(25),
        backgroundColor: redColor,
        borderColor: redShadowColor,
        borderWidth: 8,
        margin: 10,
        borderRadius: wp(25) / 2,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    sosText: {
        color: 'white',
        textAlign: 'center',
        fontSize: 18
    }
})
export const customerLocationStyles = StyleSheet.create({
    map: {
        height: hp(80),
        borderRadius: 40,
        width: wp(100),
        overflow: 'hidden'
    },
    buttonText: {
        color: 'white',
        marginRight: 30,
        textAlign: 'center',
        fontSize: hp(2.2)
    },
    button: {
        width: wp(80),
        alignSelf: 'center',
        borderRadius: 25,
        height: hp(7),
    },
    address: {
        color: blueDarkColor,
        textAlign: 'center',
        margin: 10,
    }
})
export const fillCustomerAddressStyles = StyleSheet.create({
    wraper: {
        borderTopLeftRadius: 40,
        borderTopRightRadius: 40,
        height: height - 80,
        width: wp(100),
        justifyContent: 'center',
        alignItems: 'center'
    },
    textInput: {
        borderWidth: 1,
        borderRadius: 8,
        borderColor: '#EEEEEE',
        margin: 5,
        alignItems: 'center',
        justifyContent: 'center',
        width: wp(100) - 90,
        height: 45,
    },
    textMidInput: {
        borderWidth: 1,
        borderRadius: 8,
        borderColor: '#EEEEEE',
        margin: 5,
        alignItems: 'center',
        justifyContent: 'center',
        width: (wp(100) / 2) - 50,
        height: 45,
    },
    addresstext: {
        fontSize: 16,
        color: 'white',
        textAlign: 'center',
        margin: 10,
    },
    addressIcon: {
        width: 80,
        height: 80,
        resizeMode: 'contain'
    }
})
export const profileStyles = StyleSheet.create({
    textInput: {
        borderWidth: 1,
        borderRadius: 8,
        borderColor: 'white',
        margin: 5,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        width: wp(100) - 90,
        height: 45,
    },
    textInsideInput: {

        width: wp(100) - 90,
        color: 'white',
    },
    textMidInput: {
        borderWidth: 1,
        borderRadius: 8,
        borderColor: 'white',
        alignItems: 'center',
        justifyContent: 'center',
        width: wp(42),
        height: 45,
    },
    wraper: {
        paddingTop: 10,
        borderTopLeftRadius: 40,
        borderTopRightRadius: 40,
        height: height - 60,
        width: wp(100),
        justifyContent: 'space-between',
        // paddingBottom: 140,
        alignItems: 'center'
    },
});
export const requestInfoStyles = StyleSheet.create({
    infoWraper: {
        width: wp(100) - 40,
        borderRadius: 20,
        marginTop: 10,
        paddingLeft: 10,
        paddingRight: 10,
        backgroundColor: 'white',
        marginLeft: 20,
        marginRight: 20,
        paddingBottom: 20,
        alignItems: 'center',
        shadowColor: "#000000cc",
        shadowOffset: {
            width: 0,
            height: 3,
        },
        shadowOpacity: 0.05,
        shadowRadius: 2.27,
        elevation: 2,
    },
    headerWraper: {
        width: wp(80),
        borderBottomColor: '#F8F8F8',
        borderBottomWidth: 1,
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf:'center',
        padding: 5,
        marginBottom: 5,
        justifyContent: 'space-around'
    },
    boxWraper: {
        width: wp(70),
        backgroundColor: 'white',
        borderRadius: 15,
        minHeight: wp(30),
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-around',
        paddingTop: wp(20) / 2
    },
    diamondWraper: {
        width: wp(20),
        height: wp(20),
        top: -(wp(20) / 2),
        borderRadius: wp(20) / 2,
        position: 'absolute',
        alignSelf: 'center',
        overflow: 'hidden',
        borderWidth: 5,
        borderColor: '#31BFCF',
        backgroundColor: 'white',
        justifyContent: 'center',
        alignItems: 'center'
    }
})
export const walletStyles = StyleSheet.create({
    wraper: {
        borderTopLeftRadius: 40,
        borderTopRightRadius: 40,
        height: hp(93),
        width: wp(100),
        justifyContent: 'center',
        alignItems: 'center'
    },
    walletBox: {
        alignSelf: 'center'
    },
    diamondWraper: {
        width: 70,
        height: 70,
        borderRadius: 35,
        position: 'absolute',
        alignSelf: 'center',
        borderWidth: 10,
        borderColor: '#31BFCF',
        backgroundColor: 'white',
        justifyContent: 'center',
        alignItems: 'center'
    }
})
export const settingStyles = StyleSheet.create({
    wraper: {
        borderTopLeftRadius: 40,
        borderTopRightRadius: 40,
        height: height - 60,
        width: wp(100),
        paddingTop: 40,
        alignItems: 'center'
    },
    itemWraper: {
        backgroundColor: 'white',
        width: wp(100) - 60,
        height: 50,
        borderRadius: 10,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: 20,
        paddingRight: 20,
    }
})

export const viewCartStyles = StyleSheet.create({
    wraper: {
        borderTopLeftRadius: 40,
        borderTopRightRadius: 40,
        height: hp(93),
        width: wp(100),
        alignItems: 'center'
    },
    lineVert: {
        width: wp(100) - 100,
        height: 1,
        backgroundColor: '#F8F8F8',
        alignSelf: 'center'
    },
    lineHorz: {
        width: 1,
        height: 25,
        backgroundColor: '#F8F8F8',
        alignSelf: 'center'
    }

})
